import { formatInTimeZone } from 'date-fns-tz';

export const getLuminance = (hexColor: string): number => {
    const hex = hexColor.replace('#', '');
    const r = parseInt(hex.substring(0, 2), 16) / 255;
    const g = parseInt(hex.substring(2, 4), 16) / 255;
    const b = parseInt(hex.substring(4, 6), 16) / 255;
    const gammaCorrect = (channel: number) =>
        channel <= 0.03928
            ? channel / 12.92
            : Math.pow((channel + 0.055) / 1.055, 2.4);
    const rLinear = gammaCorrect(r);
    const gLinear = gammaCorrect(g);
    const bLinear = gammaCorrect(b);
    return 0.2126 * rLinear + 0.7152 * gLinear + 0.0722 * bLinear;
};

export const getContrastColor = (backgroundColor: string): string => {
    const luminance = getLuminance(backgroundColor);
    return luminance > 0.5 ? 'black' : 'white';
};

export function getDatesWithFormatting(startRaw: string | Date, endRaw: string | Date, timezone?: string) {
    if (timezone) {
        const startInTz = formatInTimeZone(new Date(startRaw), timezone, "yyyy-MM-dd'T'HH:mm:ss");
        const endInTz = formatInTimeZone(new Date(endRaw), timezone, "yyyy-MM-dd'T'HH:mm:ss");
        return {
            start: new Date(startInTz),
            end: new Date(endInTz),
            startFormatted: formatInTimeZone(new Date(startRaw), timezone, 'PPpp'),
            endFormatted: formatInTimeZone(new Date(endRaw), timezone, 'PPpp')
        };
    }
    const start = new Date(startRaw);
    const end = new Date(endRaw);
    return {
        start, end, startFormatted: start.toLocaleString(), endFormatted: end.toLocaleString()
    };
}

export function escapeAndFormatComment(raw?: string | undefined) {
    if (!raw) return '';
    const s = String(raw);
    const escaped = s
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    return `Comment: ${escaped.replace(/\n/g, '<br/>')}`;
}

export const hasCommentText = (raw?: string | undefined): boolean =>
    !!(raw && String(raw).trim().length > 0);

export function getCommentPrefix(raw?: string | undefined, textColor?: string): string {
    if (!hasCommentText(raw)) return '';
    const colorAttr = textColor ? ` style="color: ${textColor};"` : '';
    return `<span class="ts-info" title=""${colorAttr}>&#8505;</span>&nbsp;`;
}

export const applyDateRangeBuffer = (
    startOfDay: Date,
    endOfDay: Date
): { minDate: Date; maxDate: Date } => {
    return { minDate: startOfDay, maxDate: endOfDay };
};